import React from "react";
import RightSidebarGlobal from "../../Components/RightSidebarGlobal";

function Inputs(){

    return (
        <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Our Mission</h1>

    <p>BENFED is involved in procurement, supply and distribution of different agricultural inputs, ie. Seeds, Insecticides, Pesticides, Herbicides,
 Micronutrients etc through its vast network of Cooperative Societies throughout the state of West Bengal. It supplies under the supervision of 
 different Government departments such as West Bengal State Seed Corporation, Sunderban Development Board, and Directorate of Forest Officer etc. 
 BENFED through its enormous channels makes it possible to supply various agricultural inputs to remote areas of West Bengal, resulting in higher 
 agricultural productivity. At present BENFED has a product portfolio ranging to more than 1000 products of various brands and has a 
future vision to increase the portfolio according to various needs and demands of the market.</p>

    </div>
    <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div>

    </div>
    </div>

    </>
    )
}

export default Inputs